import { AuthenticatedDataType } from '../lib/types/types';

/**
 * Module-level auth store — updated by AuthContext when auth state changes.
 * This allows non-hook plain functions (tree structure builders etc.) to read
 * auth data without hooks or localStorage.
 *
 * The accessToken JWT itself is in an HttpOnly cookie and is NOT accessible here.
 * Only metadata (organisationId, personId, etc.) is available.
 */
let _authData: AuthenticatedDataType | null = null;

/**
 * Called by AuthContext whenever authenticatedData changes.
 * This keeps the module-level store in sync with React state.
 */
export function setAuthStore(data: AuthenticatedDataType | null): void {
	_authData = data;
}

/**
 * Read-only access to the current auth data.
 * Use in non-hook contexts (tree structure builders, plain functions).
 * Returns null if not authenticated.
 */
export const getLocalstorageToken = (): AuthenticatedDataType | null => {
	return _authData;
};

/**
 * DEPRECATED: JWT is now in HttpOnly cookie, not accessible to JS.
 * Returns empty string for backward compatibility.
 */
export const getUserJwt = (): string => {
	return '';
};

/**
 * DEPRECATED: Use AuthContext loading state instead.
 */
export const isUserLoggedIn = (): boolean => {
	return _authData !== null;
};
